import { render, staticRenderFns } from "./ViewTan.vue?vue&type=template&id=65b05af4&"
import script from "./ViewTan.vue?vue&type=script&lang=js&"
export * from "./ViewTan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports